import { render, staticRenderFns } from "./owner-photos-slider.vue?vue&type=template&id=4c0a4f1b"
import script from "./owner-photos-slider.vue?vue&type=script&lang=js"
export * from "./owner-photos-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports